<div ngbDropdown class="d-inline-block">
    <button class="btn btn-outline-primary nav-link" id="versionDropdown" ngbDropdownToggle><fa-icon [icon]="['fas', 'info']"></fa-icon></button>
    <div ngbDropdownMenu class="dropdown-menu-right" aria-labelledby="versionDropdown">
        <button ngbDropdownItem (click)="checkForUpdates()">Version: {{version}}</button>
        <div class="dropdown-divider"></div>
<!--        <button ngbDropdownItem>Help Centre</button>-->
        <button [routerLink]="['tos']" ngbDropdownItem>Terms of Service</button>
    </div>
</div>
